import { useTenantFeatures } from "@src/features/tenants";
import { resolveReportEntitlements, type ReportEntitlements } from "@src/features/reports/entitlements";

/**
 * The tenant's report entitlements, projected from what its assets are hired
 * for. Costs no request of this page's own - see {@link useTenantFeatures}.
 */
export function useReportEntitlements(): ReportEntitlements {
  return resolveReportEntitlements(useTenantFeatures());
}
